import {
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';

import {
  NgbActiveModal
} from '@ng-bootstrap/ng-bootstrap';

export type PopupType =
  | 'success'
  | 'error'
  | 'warning'
  | 'info';

@Component({
  selector: 'app-message-popup',
  standalone: false,
  templateUrl:
    './message-popup.component.html',
  styleUrl:
    './message-popup.component.scss',

  /*
   * NgbModal renders its wrapper outside this component.
   * ViewEncapsulation.None allows the component stylesheet
   * to style the modal window and backdrop.
   */
  encapsulation: ViewEncapsulation.None
})
export class MessagePopupComponent {
  @Input() title = 'Message';
  @Input() message = '';

  @Input() type: PopupType = 'info';

  @Input() confirmText = 'OK';
  @Input() cancelText = 'Cancel';

  @Input() showCancel = false;
  @Input() closable = true;

  /*
   * Text-confirmation properties.
   * Example expectedText:
   * DELETE
   * DELETE ALL
   */
  @Input() requireTextConfirmation = false;
  @Input() expectedText = '';
  @Input() inputLabel = '';
  @Input() inputPlaceholder = '';
  @Input() caseSensitive = false;

  confirmationValue = '';

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  get iconClass(): string {
    switch (this.type) {
      case 'success':
        return 'bi bi-check-circle-fill';

      case 'error':
        return 'bi bi-x-circle-fill';

      case 'warning':
        return 'bi bi-exclamation-triangle-fill';

      default:
        return 'bi bi-info-circle-fill';
    }
  }

  get confirmationMatches(): boolean {
    if (!this.requireTextConfirmation) {
      return true;
    }

    const entered =
      this.confirmationValue.trim();

    const expected =
      this.expectedText.trim();

    if (!entered || !expected) {
      return false;
    }

    return this.caseSensitive
      ? entered === expected
      : entered.toUpperCase() ===
          expected.toUpperCase();
  }

  get confirmDisabled(): boolean {
    return (
      this.requireTextConfirmation &&
      !this.confirmationMatches
    );
  }

  onConfirmationInput(
    event: Event
  ): void {
    this.confirmationValue =
      (
        event.target as HTMLInputElement
      ).value;
  }

  confirm(): void {
    if (this.confirmDisabled) {
      return;
    }

    this.activeModal.close(true);
  }

  cancel(): void {
    this.activeModal.dismiss(false);
  }

  close(): void {
    this.activeModal.dismiss(false);
  }
}